var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{staticClass:"customerNotification",attrs:{"title":_vm.$t('customerNotification.process'),"icon":"envelope-open-text"}},[_c('CustomerNotificationProcess')],1)}
var staticRenderFns = []

export { render, staticRenderFns }